// @ts-nocheck
import {Column} from 'react-table'
import {PropertiesNameCell} from './PropertiesNameCell'
import {PropertiesFunctionCell} from './PropertiesFunctionCell'
import {PropertiesActionsCell} from './PropertiesActionsCell'
import {PropertiesCustomHeader} from './PropertiesCustomHeader'
import {PropertiesPercentageCell} from './PropertiesPercentageCell'
import {PropertiesParticipations} from '../../core/_models'

const propertiesColumns: ReadonlyArray<Column<PropertiesParticipations>> = [
  {
    Header: (props) => (
      <PropertiesCustomHeader
        tableProps={props}
        title='COMMON.INPUT_NAME'
        className='fs-9 text-center flex-row-fluid flex-center'
      />
    ),
    id: 'name',
    Cell: ({...props}) => (
      <PropertiesNameCell propertiesParticipations={props.data[props.row.index]} />
    ),
  },
  {
    Header: (props) => (
      <PropertiesCustomHeader
        tableProps={props}
        title='OWNER.FUNCTION'
        className='fs-9 text-center flex-row-fluid flex-center'
      />
    ),
    id: 'function',
    Cell: ({...props}) => (
      <PropertiesFunctionCell propertiesParticipations={props.data[props.row.index]} />
    ),
  },
  {
    Header: (props) => (
      <PropertiesCustomHeader
        tableProps={props}
        title='COMMON.INPUT_PERCENTEGE'
        className='fs-9 text-center flex-row-fluid flex-center'
      />
    ),
    id: 'percentage',
    Cell: ({...props}) => (
      <PropertiesPercentageCell propertiesParticipations={props.data[props.row.index]} />
    ),
  },

  {
    Header: (props) => (
      <PropertiesCustomHeader
        tableProps={props}
        title='MENU.ACTIONS'
        className='fs-9 text-center'
      />
    ),
    id: 'actions',
    Cell: ({...props}) => <PropertiesActionsCell data={props.data[props.row.index]} />,
  },
]

export {propertiesColumns}
